import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../service/main.service';
import { ActivatedRoute } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { DatePipe, Location } from '@angular/common';
import { LocalStorageService } from '../../service/local-storage.service';
import { ApiUrls } from '../../apiRouts';

@Component({
  selector: 'app-add-edit-sub-event',
  templateUrl: './add-edit-sub-event.component.html',
  styleUrl: './add-edit-sub-event.component.scss'
})
export class AddEditSubEventComponent {
  subEventForm: any = FormGroup;
  submitted = false;
  action: any;
  userId: any;
  selectedSubEventData: any;
  eventId:any;
  datePipe = new DatePipe("en-US")
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private route: ActivatedRoute,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService
  ) {
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.action = params['action'] || '';
      this.eventId =  params['event_id'] || '';
    });
    this.subEventForm = this.fb.group({
      sub_event_name: ['', [Validators.required]],
      from_date : ['', [Validators.required]],
      to_date : ['', [Validators.required]],
    })
    if (this.action == 'Edit') {
      this.selectedSubEventData = this.mainService.selectedSubEventData;
      this.subEventForm.patchValue(this.selectedSubEventData);
    }
  }

  get f() {
    return this.subEventForm.controls;
  }
  
  goBackToPrevPage() {
    this.location.back();
  }

  submit() {
     this.submitted = true;
    if(this.subEventForm.valid){
    if (this.action == 'Edit') {
      var data: any = {
        sub_event_id:this.selectedSubEventData.sub_event_id ,
       // event_id :Number(this.eventId),
        sub_event_name: this.subEventForm.value.sub_event_name,
        from_date:  this.datePipe.transform(this.subEventForm.value.from_date, "yyyy-MM-dd"),
        to_date: this.datePipe.transform(this.subEventForm.value.to_date, "yyyy-MM-dd"),
        created_by: this.userId,
        Action: 'UPDATE'
      }
      this.mainService.postApi(ApiUrls.crudSubEvent, data, 1).subscribe(res => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.goBackToPrevPage();
        }else{
          this.toasterService.toastSuccess(res.response);
        }
      })
    } else {
      var data: any = {
        sub_event_id: 0,
        event_id :Number(this.eventId),
        sub_event_name: this.subEventForm.value.sub_event_name,
        from_date:  this.datePipe.transform(this.subEventForm.value.from_date, "yyyy-MM-dd"),
        to_date: this.datePipe.transform(this.subEventForm.value.to_date, "yyyy-MM-dd"),
        created_by: this.userId,
        Action: 'INSERT'
      }
      this.mainService.postApi(ApiUrls.crudSubEvent, data, 1).subscribe(res => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.goBackToPrevPage();
        }else{
          this.toasterService.toastSuccess(res.response);
        }
      })
    }
  }
}
}
